module.exports = __webpack_public_path__ + "media/1_3-10.60a0bf13.mp3";